import { useTranslation } from "react-i18next";

import { BAY_FILTERS, BayFilter } from "../../utils/bayCardState";
import classNames from "../../utils/classNames";

interface BayStatusFiltersProps {
  value: BayFilter;
  counts: Record<BayFilter, number>;
  onChange: (filter: BayFilter) => void;
}

const filterLabel = (filter: BayFilter): string => {
  switch (filter) {
    case "attention":
      return "Needs attention";
    case "running":
      return "Timer running";
    case "idle":
      return "Idle";
    default:
      return "All bays";
  }
};

export default function BayStatusFilters({ value, counts, onChange }: BayStatusFiltersProps) {
  const { t } = useTranslation("production");

  return (
    <div className="flex gap-1.5 flex-wrap" role="group" aria-label={t("Filter bays")}>
      {BAY_FILTERS.map((filter) => {
        const active = filter === value;
        return (
          <button
            key={filter}
            type="button"
            onClick={() => onChange(filter)}
            aria-pressed={active}
            className={classNames(
              "inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium",
              active
                ? "bg-gray-900 border-gray-900 text-white"
                : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50"
            )}
          >
            <span>{t(filterLabel(filter))}</span>
            <span className={classNames("tabular-nums", active ? "text-gray-300" : "text-gray-500")}>
              {counts[filter]}
            </span>
          </button>
        );
      })}
    </div>
  );
}
